import { Typography } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LgSpace, SmSpace, Section, Button } from 'm2m.components';
import { formatDate } from 'utils/date';
import { formatNumber } from 'utils/number';
import { RootState } from 'store';
import { transferenciaTipoDescriptions } from 'common/genericDescriptions';
import { useCallback, useEffect, useState } from 'react';
import { OperacaoTransferenciaResponse } from 'common/genericTypes';
import { addCpfCnpjMask } from 'utils/mask';

type ComponentParams = { transferenciaId: string };

type Props = RouteComponentProps<ComponentParams>;

const DetalhesTransferencia: React.FC<Props> = (props) => {

  const { transferenciaId } = props.match.params;
  const [operacao, setOperacaoTransferencia] = useState<OperacaoTransferenciaResponse>();

  const history = useHistory();
  const dispatch = useDispatch();

  const { getOperacaoTransferencia } = useSelector((state: RootState) => state.operacaoApi);

  const getOperacao = useCallback(async () => {
    try {
      const result = await getOperacaoTransferencia(dispatch, transferenciaId, true);
      setOperacaoTransferencia(result);
    } catch {}
  }, [dispatch, getOperacaoTransferencia, transferenciaId]);

  const openComprovante = async (address: string, name: string) => {
    try {
        const link = document.createElement('a');
        link.href = address;
        link.target = '_blank';
        link.download = `Comprovante_${name}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };

  const goBack = () => history.push('/operacoes/gerenciar', { initialTab: 3 });

  useEffect(() => {
    getOperacao();
  }, [getOperacao]);

  return (
    <div style={{ marginRight: 40 }}>
      <Typography variant="h1">{`Transferência`}</Typography>
      <SmSpace />

      <Button onClick={goBack} variant="contained" color="primary">
        {'Voltar para a página anterior'}
      </Button>

      <LgSpace />
      {operacao?.transferencia &&
        <div>
          <Section title={'Detalhes da Transferência'} defaultGrid>
            <div>
              <Typography variant="body2">{'Tipo:'}</Typography>
              <Typography variant="body1">
                {transferenciaTipoDescriptions[operacao.transferencia.tipo]}
              </Typography>
            </div>
            <div>
              <Typography variant="body2">{'Data:'}</Typography>
              <Typography variant="body1">{formatDate(operacao.dataDeCriacao, "DD/MM/YYYY")}</Typography>
            </div>
            <div>
              <Typography variant="body2">{'Código do Instrumento:'}</Typography>
              <Typography variant="body1">{operacao.instrumentoFinanceiro.codigo}</Typography>
            </div>
            <div>
              <Typography variant="body2">{'Quantidade:'}</Typography>
              <Typography variant="body1">{formatNumber(operacao.transferencia.quantidade, { minimumFractionDigits: 0, maximumFractionDigits: 8 })}</Typography>
            </div>
            <div>
              <Typography variant="body2">{`Custodiante ${operacao.transferencia.tipo === 'CUSTODIA' ? 'Origem' : ''}`}</Typography>
              <Typography variant="body1">{operacao.transferencia.custodianteOrigem.razaoSocial}</Typography>
            </div>
            <div>
              <Typography variant="body2">{'CNPJ:'}</Typography>
              <Typography variant="body1">{addCpfCnpjMask(operacao.transferencia.custodianteOrigem.cnpj!)}</Typography>
            </div>
            {operacao.transferencia.tipo === 'CUSTODIA' && <div>
              <Typography variant="body2">{'Custodiante Destino:'}</Typography>
              <Typography variant="body1">{operacao.transferencia.custodianteDestino.razaoSocial}</Typography>
            </div>}
            {operacao.transferencia.tipo === 'CUSTODIA' && <div>
              <Typography variant="body2">{'CNPJ:'}</Typography>
              <Typography variant="body1">{addCpfCnpjMask(operacao.transferencia.custodianteDestino.cnpj!)}</Typography>
            </div>}
            <div>
              <Typography variant="body2">{`Investidor ${operacao.transferencia.tipo === 'TITULARIDADE' ? 'Origem' : ''}`}</Typography>
              <Typography variant="body1">{operacao.transferencia.investidorOrigem.razaoSocial}</Typography>
            </div>
            <div>
              <Typography variant="body2">{'CPF/CNPJ:'}</Typography>
              <Typography variant="body1">{addCpfCnpjMask(operacao.transferencia.investidorOrigem.cpfCnpj!)}</Typography>
            </div>
            {operacao.transferencia.tipo === 'TITULARIDADE' && <div>
              <Typography variant="body2">{'Investidor Destino:'}</Typography>
              <Typography variant="body1">{operacao.transferencia.investidorDestino.razaoSocial}</Typography>
            </div>}
            {operacao.transferencia.tipo === 'TITULARIDADE' && <div>
              <Typography variant="body2">{'CPF/CNPJ:'}</Typography>
              <Typography variant="body1">{addCpfCnpjMask(operacao.transferencia.investidorDestino.cpfCnpj!)}</Typography>
            </div>}
          </Section>
          {operacao.transferencia.anexos.length > 0 && (
            <Section title={'Anexos'} defaultGrid>
              {operacao?.transferencia?.anexos.map((doc) => (
                <Button startIcon={<GetApp />} onClick={() => openComprovante(doc.address, doc.fileName)} variant="text">
                  {(doc.fileName ? doc.fileName : 'Documento') + doc.extension}
                </Button>
              ))}
            </Section>
          )}
        </div>
      }
      <LgSpace />
    </div>
  );
};

export default DetalhesTransferencia;
